/**
 *
 * @param {Number} num
 */
export const roundOfNumber = (num) => Math.round((num + Number.EPSILON) * 100) / 100;
